import { useState } from 'react';
import { Page, Header, Content, Link } from '@backstage/core-components';
import { TechRadarComponent } from '@backstage-community/plugin-tech-radar';
import { makeStyles } from '@material-ui/core/styles';
import { Input, Grid } from '@material-ui/core';
import TechRadarLogo from '../../assets/techradar-puzzle-logo.svg';

const useStyles = makeStyles(() => ({
  overflowXScroll: {
    overflowX: 'scroll',
  },
}));

export const CustomTechRadarPage = () => {
  const classes = useStyles();
  const [searchText, setSearchText] = useState('');

  return (
    <Page themeId="tool">
      <Header
        pageTitleOverride="Puzzle Tech Radar"
        title={
          <img
            src={TechRadarLogo}
            alt="Puzzle Tech Radar"
            style={{ height: '40px', width: 'auto' }}
          />
        }
        subtitle="Technology Radar for Puzzle ITC"
      />
      <Content className={classes.overflowXScroll}>
        <Grid
          container
          direction="row"
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Link
              to="https://portal.puzzle.ch/docs/default/resource/puzzle-backstage-technology-radar"
              target="_blank"
              rel="noopener noreferrer"
            >
              Documentation
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Input
              id="tech-radar-filter"
              type="search"
              placeholder="Filter"
              onChange={e => setSearchText(e.target.value)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} direction="row">
          <Grid item xs={12} sm={6} md={4}>
            <TechRadarComponent
              searchText={searchText}
              width={1500}
              height={800}
            />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
